/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import { API_URL, downloadFile } from"../../network"


// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";
import { Tooltip } from 'reactstrap';
import classnames from 'classnames';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import { toast } from 'react-toastify';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import InnerImageZoom from 'react-inner-image-zoom';
import { Link } from "react-router-dom";
import DownloadLink from "react-download-link";
import { Document, Page } from 'react-pdf';
import { MemorySharp } from "@material-ui/icons";




function Memo(props) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [delettingFile, setDeletingFile] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [curSrc, setCurSrc] = useState(null);
  const [adminFile, setAdminFile] = useState(false)
  const [deleteConfirm, setDeleteConfirm] = useState(false)
  const [deleteId, setDeleteId] = useState(false)
  

  const fileRef = useRef(null);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfScale, setPdfScale] = useState(0.8)
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(() => {
  },[props.selectedUser]);

  const toggletooltip = () => setTooltipOpen(!tooltipOpen);

  const memos = props.memos
  return (
    <>    
      <Row className="mt-0">
        <Col md="12">
          {
            memos.map((memo, index)=>{
              return (
                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <div className="memo-avata mr-2">
                        {memo.logo ?
                          <img src={'data:image/png;base64,'+memo.logo} ></img>:
                          <div style={{background:'#eeeeee', width:'100%', height:'100%'}}></div>
                        }
                      </div>
                      <span className="memo-username">{memo.user_name}</span>
                    </div>
                    <div className="memo-time">
                      <span className="mr-2">{memo.created_at}</span>
                      <i style={{fontSize:17, cursor:'pointer'}} className="fa fa-trash" onClick={()=>{setDeleteConfirm(true); setDeleteId(memo['id'])}}></i>
                    </div>
                  </div>
                  <div className="memo-content mt-1">
                    {
                      memo.message_format == 'file'?
                      <a href="javascript:void(0)" onClick={(e)=>{downloadFile(`/quotes/getmemofile/?fileName=${memo.content}&filePath=${memo.file_path}`, memo.content)}}>{memo.content}</a>:
                      <div dangerouslySetInnerHTML={{ __html: memo.content }} />
                    }

                    

                  </div>
                </div>
              )
            })
          }
        </Col>
        <Modal isOpen={deleteConfirm} toggle={()=>setDeleteConfirm(false)} >
          <ModalHeader toggle={()=>setDeleteConfirm(false)}>Confirm</ModalHeader>
          <ModalBody>
            Are you sure to remove this note?
          </ModalBody>
          <ModalFooter>
            <Button color="primary" size="sm" onClick={()=>{props.removememo(deleteId); setDeleteConfirm(false)}}>Yes</Button>{' '}
            <Button color="secondary" size="sm" onClick={()=>setDeleteConfirm(false)}>No</Button>
          </ModalFooter>
        </Modal>
      </Row>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Memo);
